/*
 * @Author: changcheng
 * @LastEditTime: 2023-02-14 09:48:25
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./index.less";
import { RightCircleOutlined } from "@ant-design/icons";
import axios from "@/axios/axios";
import { message } from "antd";
import * as actions from "@/store/actions";

const RecommendCourse: FC<any> = ({ history, course = {}, setFrom }) => {
  const jump = (data: any) => {
    setFrom({ from: { path: "/index/home", name: "首页" } });
    history.push({ pathname: `/index/subject/${data.id}` });
  };
  useEffect(() => {
  }, []);
  return (
    <div className={"recommend-course-module"}>
      <div className={"home-title-bar"}>
        <span className={"title"}>推荐项目</span>
        {/* <div className={"title-type"}>
          {typeList.map((item: any, i: number) => (
            <span
              key={i}
              onClick={() => {
                history.push({
                  pathname: "/index/subjectNavigation",
                  search: `?subjectId=${item.id}`,
                });
              }}
            >
              {item.name}
            </span>
          ))}
        </div> */}
        <span
          className={"more"}
          onClick={() => {
            history.push({ pathname: "/index/subjectNavigation" });
          }}
        >
          更多
          <RightCircleOutlined
            style={{ fontSize: "16px", marginLeft: "8px" }}
          />
        </span>
      </div>
      <div className={"recommend-course-list"}>
        {course.map((recommend: any, i: number) => (
          <div
            key={i}
            className={"content-course-item"}
            onClick={() => {
              jump(recommend);
            }}
          >
            <div className={"item-img"}>
              <img src={recommend.imageAllPath} alt="" />
            </div>
            <div className={"item-text"}>
              <div className={"p-box"}>
                <p>项目负责人：{recommend.itemLeaderName}</p>
                <p>学分：{recommend.creditInfo}</p>
                <p>编号：{recommend.itemCode}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(withRouter(RecommendCourse));
